export default {
  nav: {
    connect: "Купить",
    language: "Язык"
  },
  about: {
    title: "О MINO",
    description: "MINO - это мем-проект, созданный увлечёнными фанатами Тетриса из России совместно с Serbfund. Это не просто дань уважения легендарной игре, $MINO - это Web3-эксперимент, превращающий коллективные действия в общий визуальный опыт на блокчейне.",
    quote: "Мы верим, что Тетрис это больше, чем просто игра — это культурный символ и пример того, как деген-культура упорядочивает хаос."
  },
  hero: {
    title: "Привет, я Мино!",
    subtitle: "Я четверть блока тетромино.",
    buyButton: "КУПИТЬ $MINO"
  },
  footer: {
    buy: "Купить $MINO",
    twitter: "X/Twitter",
    telegram: "Telegram",
    dexscreener: "DexScreener",
    contractAddress: "CA: ",
    copySuccess: "Адрес контракта скопирован!",
    copyError: "Не удалось скопировать адрес"
  },
  features: {
    title: "У нас действительно",
    subtitle: "СИЛЬНЫЙ ФУНДАМЕНТ",
    partnerships: {
      title: "Стратегические Партнерства",
      description: "Memecoin установил стратегические партнерские отношения с ведущими игроками в криптоиндустрии, а также с ключевыми инфлюенсерами и платформами в мем-сообществе."
    },
    community: {
      title: "Поддержка Сообщества",
      description: "Благодаря активному взаимодействию, открытому общению и совместным инициативам, Memecoin создает сильное чувство общности среди своих участников."
    },
    ecosystem: {
      title: "Растущая Экосистема",
      description: "С растущей сетью пользователей, разработчиков и инвесторов, Memecoin предлагает уникальные возможности для сотрудничества, нетворкинга и взаимной поддержки."
    }
  }
}; 